module.exports = __webpack_public_path__ + "static/img/egg_g_05.f190559.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defult/img/eggs/g/egg_g_05.png
// module id = ElJZ
// module chunks = 1